import { Project } from "@/types/projects.types";
import * as Yup from "yup";

export const projectVmsValidationSchema = Yup.object<Project>().shape({});
